import { FONT_OPTIONS, ICON_LIBRARY_OPTIONS, THEME_OPTIONS, useAppearance, type IconLibrary } from "../appearance";

function SettingsRow({ label, children }: { label: string; children: React.ReactNode }) {
  return (
    <div className="appearance-row">
      <label className="appearance-row-label">{label}</label>
      <div className="appearance-row-control">{children}</div>
    </div>
  );
}

export default function AppearanceSettings() {
  const { fontId, iconLibrary, theme, resetAppearance, setFontId, setIconLibrary, setTheme } = useAppearance();

  return (
    <div className="appearance-settings" aria-labelledby="appearance-settings-title">
      <div className="appearance-settings-header">
        <h3 id="appearance-settings-title">Appearance</h3>
        <button className="appearance-reset" onClick={resetAppearance} type="button">Reset defaults</button>
      </div>
      <div className="appearance-settings-body">
        <SettingsRow label="Theme">
          <select className="settings-select" onChange={(event) => setTheme(event.target.value as typeof theme)} value={theme}>
            {THEME_OPTIONS.map((option) => <option key={option.id} value={option.id}>{option.label}</option>)}
          </select>
        </SettingsRow>
        <SettingsRow label="Font">
          <select className="settings-select" onChange={(event) => setFontId(event.target.value)} value={fontId}>
            {FONT_OPTIONS.map((font) => <option key={font.id} value={font.id}>{font.label}</option>)}
          </select>
        </SettingsRow>
        <SettingsRow label="Icon library">
          <select className="settings-select" onChange={(event) => setIconLibrary(event.target.value as IconLibrary)} value={iconLibrary}>
            {ICON_LIBRARY_OPTIONS.map((library) => <option key={library.id} value={library.id}>{library.label}</option>)}
          </select>
        </SettingsRow>
      </div>
    </div>
  );
}
